<template lang="html">
  <section class="app-sidebar">
    <nav class="sidebar sidebar-offcanvas" id="sidebar">
      <ul class="nav">
        <ul class="navbar-nav ml-auto">
          <template>

            <li class="nav-item nav-profile">
              <a href="#" class="nav-link">
                <div class="profile-image">
                  <img class="img-xs rounded-circle" src="../../assets/icons/user.svg" alt="">
                  <div v-if="is_online === 'yes'" class="dot-indicator bg-success"></div>
                  <div v-else class="dot-indicator bg-danger"></div>
                </div>
                <div class="text-wrapper">
                  <p class="profile-name">{{firstname}}</p>
                  <p class="designation">{{email}}</p>
                </div>
              </a>
            </li>
            <li class="nav-item">
              <div class="d-flex justify-content-center" style="margin-bottom: 16px">
                <b-button v-if="is_online === 'yes'" variant="success" class="btn-rounded" @click="changeStatusUser()">Je bent ONLINE</b-button>
                <b-button v-else variant="danger" class="btn-rounded" @click="changeStatusUser()">Je bent OFFLINE</b-button>
              </div>
            </li>
<!--            <div class="nav-item">{{user.data.displayName}}</div>-->
            <li class="nav-item">
              <button class="btn btn-primary submit-btn btn-block" @click="signOut()">Afmelden </button>

<!--              <a class="nav-link" @click.prevent="signOut"></a>-->
            </li>
          </template>
<!--          <template v-else>-->
<!--            <li class="nav-item">-->
<!--              <router-link to="login" class="nav-link">Login</router-link>-->
<!--            </li>-->
<!--            <li class="nav-item">-->
<!--              <router-link to="register" class="nav-link">Register</router-link>-->
<!--            </li>-->
<!--          </template>-->
        </ul>
<!--        <li >-->
<!--          <div style="width: 50px; margin-left:40px; background-color: transparent">-->
<!--            <img src="../../assets/icons/red_circle.svg" alt="">-->
<!--          </div>-->
<!--        </li>-->
        <li class="nav-item nav-category">Menu</li>
        <li class="nav-item">
          <a class="nav-link">
            <i class="menu-icon typcn-coffee"></i>
            <router-link class="typcn menu-title" to="/campagnes">Campagnes</router-link>
          </a>
        </li>
        {{user.role}}
        <li class="nav-item" v-if="role === 'admin' || role === 'officemanager'">
          <a class="nav-link">
            <i class="menu-icon typcn-coffee"></i>
            <router-link class="typcn menu-title" to="/users/">Gebruikers</router-link>
          </a>
        </li>
        <li class="nav-item" v-if="role === 'admin' || role === 'officemanager'">
          <a class="nav-link">
            <i class="menu-icon"></i>
            <router-link class="typcn menu-title" to="/logs/">Logs</router-link>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link">
            <i class="menu-icon typcn-coffee"></i>
            <router-link class="typcn menu-title" to="/instellingen/">Instellingen</router-link>
          </a>
        </li>
<!--        <li class="nav-item">-->
<!--          <a class="nav-link">-->
<!--            <i class="menu-icon typecn-coffee"></i>-->
<!--            <a class="typecn menu-title" @click="signOut">Afmelden</a>-->
<!--&lt;!&ndash;            <button  @click="signOut()">Afmelden </button>&ndash;&gt;-->
<!--          </a>-->
<!--        </li>-->

<!--          &lt;!&ndash;              <a class="nav-link" @click.prevent="signOut"></a>&ndash;&gt;-->
<!--&lt;!&ndash;          class="btn btn-primary submit-btn btn-block"&ndash;&gt;-->
<!--        </li>-->
      </ul>
    </nav>
  </section>
</template>

<script lang="js">
import axios from 'axios'
import JQuery from 'jquery'
import store from '../../store'
let server = require('../../server')
// eslint-disable-next-line
let $ = JQuery
export default {
  name: 'app-sidebar',
  computed: {
    role () {
      return store.state.role
    },
    user () {
      return store.state.user
    },
    office () {
      return store.state.office
    },
    email () {
      return store.state.email
    },
    firstname () {
      return store.state.firstname
    },
    is_online () {
      return store.state.is_online
    }
  },
  methods: {
    async changeStatusUser () {
      let self = this
      try {
        await axios({
          method: 'get',
          url: server.SERVER_URL + '/change_status_for_user_with_email/' + self.email
        })
          .then(async function (response) {
            console.log('user is now ')
            console.log(response.data)
            let payload = {
              'is_online': response.data
            }
            store.commit('SET_IS_USER_ONLINE', payload)
          })
      } catch (e) {
        console.log('Error while trying to get contacts by campaign_id')
        console.log(e)
      }
    },
    signOut () {
      this.$firebase
        .auth()
        .signOut()
        .then(() => {
          store.commit('DESTROY_DATA')
          this.$router.push({ path: '/login' })
        })
    }
  },
  mounted () {
    const body = document.querySelector('body')
    // add class 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
    console.log('user = ')
    console.log(this.user)
    document.querySelectorAll('.sidebar .nav-item').forEach(function (el) {
      el.addEventListener('mouseover', function () {
        if (body.classList.contains('sidebar-icon-only')) {
          el.classList.add('hover-open')
        }
      })
      el.addEventListener('mouseout', function () {
        if (body.classList.contains('sidebar-icon-only')) {
          el.classList.remove('hover-open')
        }
      })
    })
  },
  async computer () {
    console.log('user = ')
    console.log(this.user)
  }
}
</script>

<style scoped lang="scss">
.app-sidebar {
}
</style>



// WEBPACK FOOTER //
// src/components/partials/AppSidebar.vue